const CONFIG = {
    // 开发环境配置
    development: {
        baseUrl: "https://api.intfish.cn:18100",
		//讨论环节
		discussUrl: "https://loyal.dl-cube.com/h5",
		wssUrl: "ws://192.168.31.100:23460",
    },
    stage: {
        baseUrl: "https://www.loyal.org.cn",
		discussUrl: "https://www.loyal.org.cn/h5",
		wssUrl: "wss://www.loyal.org.cn/wss",
    },
    // 生产环境配置
    production: {
        baseUrl: "https://www.loyal.org.cn",
		discussUrl: "https://www.loyal.org.cn/h5",
		wssUrl: "wss://www.loyal.org.cn/wss",
    },
};
export default CONFIG[process.env.NODE_ENV];
